import { Dap } from '@move-frontend/dap';

export const dap = new Dap(
	process.env.DAP_API_KEY as string,
	process.env.DAP_BASE_URI as string,
);
